// Lista blanca de dominios permitidos para la creación y acceso de usuarios
// Puedes agregar o quitar dominios según la política de la organización

export const ALLOWED_DOMAINS = [
  'drummondltd.com',
  // Agrega aquí otros dominios válidos
];
